import { useSyncExternalStore } from 'react'
import { getTheme, getThemeChoice, setThemeChoice, subscribeTheme } from 'src/helpers/theme'

// The chosen theme (light, dark or as the system) and the one in effect
export const useTheme = () => {
  const choice = useSyncExternalStore(subscribeTheme, getThemeChoice)
  const theme = useSyncExternalStore(subscribeTheme, getTheme)
  return { choice, theme, setChoice: setThemeChoice }
}
